// extracted by mini-css-extract-plugin
export default {"columnStatus":"ColumnStatus_columnStatus__iYpTC"};